import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

export const PUBLIC_FALLBACK_CONTENT = {
  rating: 4.4,
  reviewsCount: 223,
  email: "",
  workingHours: "",
  legalName: "",
  crNumber: "",
  contact: {},
  destinations: [],
  reviews: [
    {
      id: "fallback-1",
      name: "Maryam Showaiter",
      stars: 5,
      text: "Amazing experience with this travel agency! They helped us with everything from start to finish and arranged a perfect trip to the Maldives. The team was super friendly, responsive, and professional. Highly recommended! 🌴✨",
    },
    {
      id: "fallback-2",
      name: "abdulrahman rashdan",
      stars: 5,
      text: "Highly recommended and very fun for kids and families.",
    },
    {
      id: "fallback-3",
      name: "Zahra Alarbash",
      stars: 5,
      text: "It was a great trip with a good group, I enjoyed it a lot! I will hopefully come again. I recommend it 10/10! ☺️",
    },
  ],
};

const ContentContext = createContext({
  content: null,
  loaded: false,
  contentError: "",
  refresh: async () => {},
  setContent: () => {},
});

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [contentError, setContentError] = useState("");

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/content", { timeout: 12000 });
      setContent(data);
      setContentError("");
      return data;
    } catch (e) {
      setContentError("تعذر تحميل إعدادات الموقع");
      return null;
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, loaded, contentError, refresh, setContent }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
